import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useRef, useState } from "react";

var useFormChange = function useFormChange() {
  var initialFormData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var formData = useRef(initialFormData);

  var _useState = useState(1),
      _useState2 = _slicedToArray(_useState, 2),
      formChangeState = _useState2[0],
      setFormChangeState = _useState2[1];

  var setFormItem = useCallback(function (keys, value) {
    var form = formData.current;
    form[keys] = value;
    setFormChangeState(function (prevFormChangeState) {
      return "".concat(parseInt(prevFormChangeState) + 1).concat(value);
    });
  }, []);
  var resetForm = useCallback(function (data) {
    var current = formData.current;

    if (data) {
      for (var name in data) {
        current[name] = data[name];
      }
    } else {
      for (var _name in current) {
        current[_name] = '';
      }
    }

    setFormChangeState(function (prevFormChangeState) {
      return "".concat(parseInt(prevFormChangeState) + 1).concat(data);
    });
  }, []);
  return [formData.current, formChangeState, setFormItem, resetForm];
};

export default useFormChange;